<div class="ms-3 mt-4 mb-2" >
  {{table.title}}
  <button type="button" class="btn btn-primary" (click)="downloadTable('api/control/report/table-export') ">
    <lucide-icon name="cloud-download" size="16"></lucide-icon>
    {{'DATATABLE.DOWNLOAD' |
    translate}}
  </button>
  <table class="mt-4 mb-2 table table-stripped" style="margin: 0 10; width: 100%;">
    <thead>
      @for (colGroups of table?.columns; track colGroups) {
        <tr>
          @for (colH of colGroups; track colH) {
            <th class="text-center"
              [attr.rowspan]="colH.rowspan" [attr.colspan]="colH.colspan">
              @if (!this.skipColumns.includes(colH.key)) {
                <div>
                  {{colH.name}}
                </div>
              }
            </th>
          }
        </tr>
      }
    </thead>


    @for (row of table?.rows; track row; let rowIndex = $index) {
      <tr style="border-bottom: 2px solid var(--border);">
        @if (!editable || (table?.rows.length>1 && rowIndex < table?.rows.length-1 && editingIndex!==rowIndex)) {
          @for (rowElement of row; track rowElement; let index = $index) {
            <td style="padding: 5px;">
              @if (rowElement.key && findCol(table?.columns,rowElement.key)) {
                <div
                  >
                  @switch (findCol(table?.columns,rowElement.key).type) {
                    @case ('static') {
                      <div class="form-group me-1 mt-2">{{rowElement.value}}
                      </div>
                    }
                    @case ('checkbox') {
                      <div class="form-group me-2">
                      </div>
                    }
                    @case ('radio') {
                      <div class="form-group me-2">
                      </div>
                    }
                    @case ('select') {
                      <div class="form-group me-2" style="text-align: center;">
                        {{getWorktype(rowElement.value)}}
                      </div>
                    }
                    @case ('calendar') {
                      <div class="form-group me-2" style="text-align: center;">
                        {{rowElement.value | date: 'dd/MM/yyyy'}}
                      </div>
                    }
                    @case ('textarea') {
                      <div class="form-group me-2" style="text-align: center;">
                        {{rowElement.value}}
                      </div>
                    }
                    @case ('user') {
                      <div class="form-group me-2" style="text-align: center;">
                        <!-- <label for="formElement.id">{{formElement.title}}:</label> -->
                        @if (this.user) {
                          <div style="width: 100%; text-align: center;">
                            @if (this.user.roles.length===1 && this.user.roles.includes('EDITOR')) {
                              <span>
                                {{user.name}} {{user.surname}}
                              </span>
                            }
                            @if (this.user?.roles.includes('CONTROLLER') ||
                              this.user?.roles.includes('COORDINATOR') ||
                              this.user?.roles.includes('CHEF') ||
                              this.user?.roles.includes('DIRECTOR_APPROVER') ||
                              this.user?.roles.includes('DIRECTOR_GENERAL')) {
                              <span>
                                {{table.rows[rowIndex][table.rows[index].length-1].fullname}}
                              </span>
                            }
                          </div>
                        }
                      </div>
                    }
                    @default {
                      <div class="form-group me-2" style="text-align: center;">
                        {{rowElement.value}}
                      </div>
                    }
                  }
                </div>
              }
            </td>
          }
          @if (table?.rows.length>1 && !this.user?.roles.includes('COORDINATOR') && editable) {
            <td style="padding: 10px;">
              <div class="form-group me-2">
                <button type="button" class="btn btn-outline-danger" (click)="openModal(template, rowIndex)">-</button>
                <button type="button" class="btn btn-outline-danger" (click)="editRow(rowIndex)">{{'CONTROL-MODULE.EDIT' | translate}}</button>
              </div>
            </td>
          }
        } @else {
          @if (!this.user?.roles.includes('COORDINATOR')) {
            @for (rowElement of row; track rowElement; let index = $index) {
              <td style="padding: 5px;">
                @if (rowElement.key && findCol(table?.columns,rowElement.key)) {
                  <div
                    >
                    @switch (findCol(table?.columns,rowElement.key).type) {
                      @case ('static') {
                        <div class="form-group me-1 mt-2">{{rowElement.value}}
                        </div>
                      }
                      @case ('checkbox') {
                        <div class="form-group me-2">
                          <app-checkbox class="form-group me-1 pb-4" style="text-align: center;" [inTable]="true"
                            [checkbox]="rowElement" [targets]="findCol(table?.columns,rowElement.key).targets"
                            (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                          </app-checkbox>
                        </div>
                      }
                      @case ('radio') {
                        <div class="form-group me-2">
                          <app-radio class="form-group me-1 pb-4" style="text-align: center;" [inTable]="true"
                            [radio]="rowElement" [targets]="findCol(table?.columns,rowElement.key).targets"
                            (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                          </app-radio>
                        </div>
                      }
                      @case ('select') {
                        <div class="form-group me-2">
                          <app-select [select]="rowElement"
                            [targets]=findCol(table?.columns,rowElement.key).targets [inTable]="true"
                            (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                          </app-select>
                        </div>
                      }
                      @case ('calendar') {
                        <div class="form-group me-2" style="text-align: center;">
                          <app-calendar [calendarElem]="rowElement" [inTable]="true" style="text-align: center;"
                            (onDateSet)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                          </app-calendar>
                        </div>
                      }
                      @case ('textarea') {
                        <div class="form-group me-2" style="text-align: center;">
                          <textarea class="form-control" id="{{rowElement.key}}" value={{rowElement.value}}
                            cols="25" rows="3" name="{{rowElement.key}}"
                            (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                          </textarea>
                        </div>
                      }
                      @case ('user') {
                        <div class="form-group me-2" style="text-align: center;">
                          <!-- <label for="formElement.id">{{formElement.title}}:</label> -->
                          @if (this.user) {
                            <div style="width: 100%; text-align: center;">
                              @if (this.user.roles.length===1 && this.user.roles.includes('EDITOR')) {
                                <span>
                                  {{user.name}} {{user.surname}}
                                </span>
                              }
                              @if (this.user.roles.includes('CONTROLLER') ||
                                this.user.roles.includes('COORDINATOR') ||
                                this.user.roles.includes('CHEF') ||
                                this.user.roles.includes('DIRECTOR_APPROVER') ||
                                this.user.roles.includes('DIRECTOR_GENERAL')) {
                                <span>
                                  {{table.rows[rowIndex][table.rows[index].length-1].fullname}}
                                </span>
                              }
                            </div>
                          }
                        </div>
                      }
                      @default {
                        <div class="form-group me-2">
                          <input type="text" class="form-control" id="{{rowElement.key}}"
                            type="{{findCol(table?.columns,rowElement.key).type}}" value={{rowElement.value}}
                            style="max-width: 100px; margin: 0 auto;" name="{{rowElement.key}}"
                            (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                          </div>
                        }
                      }
                    </div>
                  }
                </td>
              }
              @if (editingIndex===rowIndex) {
                <td style="padding: 10px;">
                  <div class="form-group me-2">
                    <button type="button" class="btn btn-outline-danger" (click)="openModal(template, rowIndex)">-</button>
                    <button type="button" class="btn btn-outline-danger" (click)="saveRow(rowIndex)">{{'CONTROL-MODULE.SAVE' | translate}}</button>
                  </div>
                </td>
              }
              @if (rowIndex===table?.rows.length-1) {
                <td style="padding: 10px;">
                  <div class="form-group me-2">
                    <button type="button" class="btn btn-outline-primary" [disabled]="!this.table.rows[rowIndex][1].value" (click)="AddRowToTable()">+</button>
                  </div>
                </td>
              }
            }
          }
        </tr>
      }
    </table>
    <ng-template #template>
      <div class="modal-body text-center">
        <p>{{'CONTROL-MODULE.SURE_TO_DELETE_TIMESHEET_RECORD' | translate}}</p>
        <button type="button" class="btn btn-outline-secondary" (click)="deleteRow()" >{{'CONTROL-MODULE.YES' | translate}}</button>
        <button type="button" class="btn btn-primary" (click)="modalRef?.hide()" >{{'CONTROL-MODULE.CANCEL' | translate}}</button>
      </div>
    </ng-template>

  </div>